class PartnerSalons extends Component {
    constructor(el) {
        super(el);
        this.DOMElementMap = null;
        this.infoWindows = [];
        this.map = null;
        this.markers = null;
        this.clusterer = null;
        this.defaultCenter = null;
        this.partnerSalonItems = this.$findAll('.PartnerSalonsItem[data-search]');
        this.searchInput = this.$find('#searchInput');
        this.searchButton = this.$find('.SearchButton');
        this.noResultsPlaceholder = this.$find('.PartnerSalonsItem.noResultsItem');
        //Nastavení debounce pro metodu filterSalons na 500ms
        this.filterSalons = this.debounce(this.filterSalons.bind(this), 500);

        this.addEventListeners();
    }

    addEventListeners() {
        let that = this;

        document.addEventListener('DOMContentLoaded', () => {
            that.DOMElementMap = document.getElementById("map");
            this.onLibrariesLoaded('google', 'markerClusterer');

            for (const item of that.partnerSalonItems) {
                item.addEventListener('click', () => this.selectPartnerSalon(item));
            }

            this.searchInput.addEventListener('keyup', () => this.filterSalons());
            //this.searchInput.addEventListener('change', () => this.filterSalons());
            this.searchButton.addEventListener('click', () => this.scrollToMap());
        });
    }

    onLibrariesLoaded(maps, clusterer) {
        let that = this;
        window.setTimeout(function () {
            if (window[maps] && window[clusterer]) {
                that.initMap();
            } else {
                that.onLibrariesLoaded(maps, clusterer);
            }
        }, 10);
    }

    /**
     * Funkce slouží pro sestavení HTML šablony tooltipu v Google mapě.
     *
     * @returns {HTMLDivElement}
     * @param salonPosition
     */
    buildInfoWindowContent(salonPosition) {
        let contentWrapper = document.createElement('div'),
            salonNameElement = document.createElement('div'),
            salonAddressElement = document.createElement('div'),
            salonContactRowElement = document.createElement('div'),
            salonPhoneElement = document.createElement('a'),
            salonEmailElement = document.createElement('a'),
            salonWebsiteElement = document.createElement('a'),
            salonImageElement = document.createElement('img'),
            salonImageContainerElement = document.createElement('div'),
            salonRatingSvgContainerElement = document.createElement('div');

        const salonRating = salonPosition.data.rating ?? null;

        salonNameElement.innerText = salonPosition.data.name;
        salonAddressElement.innerText = salonPosition.address;
        salonPhoneElement.innerText = salonPosition.data.telephoneNumber;
        salonEmailElement.innerText = salonPosition.data.email;
        salonWebsiteElement.innerText = salonPosition.data.website;
        salonRating && (salonRatingSvgContainerElement.innerHTML = salonRating); // Nastavujeme pouze, pokud je předané SVG

        contentWrapper.classList.add('MapInfoWindow');
        salonNameElement.classList.add('MapInfoWindow-name');
        salonAddressElement.classList.add('MapInfoWindow-address');
        salonContactRowElement.classList.add('MapInfoWindow--contactGroup');
        salonPhoneElement.classList.add('MapInfoWindow-phone');
        salonEmailElement.classList.add('MapInfoWindow-email');
        salonWebsiteElement.classList.add('MapInfoWindow-website');
        salonImageElement.classList.add('MapInfoWindow-image');
        salonImageContainerElement.classList.add('MapInfoWindow-image-container');
        salonRatingSvgContainerElement.classList.add('MapInfoWindow-svgRating');

        salonPhoneElement.href = "tel:" + salonPosition.data.telephoneNumber;
        salonEmailElement.href = "mailto:" + salonPosition.data.email;
        if (salonWebsiteElement.innerText !== "") {
            salonWebsiteElement.href = (!/^https?:\/\//i.test(salonPosition.data.website) ? 'https://' : '') + salonPosition.data.website;
            salonWebsiteElement.target = "_blank";
        }
        salonImageElement.src = '/data/storage/' + salonPosition.data.beauticianImage;

        salonContactRowElement.appendChild(salonPhoneElement);
        salonContactRowElement.appendChild(salonEmailElement);
        if (salonWebsiteElement.innerText !== "") {
            salonContactRowElement.appendChild(salonWebsiteElement);
        }
        salonImageContainerElement.appendChild(salonImageElement);

        if (salonPosition.data.beauticianImage) {
            contentWrapper.appendChild(salonImageContainerElement);
        }
        contentWrapper.appendChild(salonNameElement);
        contentWrapper.appendChild(salonAddressElement);
        contentWrapper.appendChild(salonContactRowElement);
        salonRating && contentWrapper.appendChild(salonRatingSvgContainerElement);

        return contentWrapper;
    }

    closeInfoWindows() {
        this.infoWindows.forEach(infoWindow => {
            infoWindow.close();
        });
    }

    initMap() {
        let that = this;
        const locations = JSON.parse(this.DOMElementMap.dataset.places);
        const centerLatlng = JSON.parse(this.DOMElementMap.dataset.centerLatlng);
        this.defaultCenter = new google.maps.LatLng(centerLatlng[0], centerLatlng[1]);
        const map = new google.maps.Map(this.DOMElementMap, {
            zoom: this.getDefaultZoom(),
            center: this.defaultCenter,
        });

        this.markers = locations.map(position => {
            const marker = new google.maps.Marker({
                position
            });
            const infoWindow = new google.maps.InfoWindow({
                content: this.buildInfoWindowContent(position),
                disableAutoPan: false,
            });
            infoWindow.partnerSalonHash = position.data.partnerSalonHash;
            infoWindow.marker = marker;
            that.infoWindows.push(infoWindow);
            marker.addListener("click", () => {
                that.closeInfoWindows();
                infoWindow.open(map, marker);
                map.panTo(marker.position);
            });
            return marker;
        });

        this.map = map;

        this.clusterer = new markerClusterer.MarkerClusterer({
            map: this.map,
            markers: this.markers // Správné předání markerů
        });
    }

    selectPartnerSalon(item) {
        this.infoWindows.forEach(infoWindow => {
            if (infoWindow.partnerSalonHash !== item.dataset.partnerSalonHash) {
                return;
            }

            this.closeInfoWindows();
            infoWindow.open(infoWindow.map, infoWindow.marker);
            this.map.setZoom(14);
            this.map.panTo(infoWindow.marker.position);
            return true;
        });
    }

    filterSalons() {
        this.closeInfoWindows();
        let query = this.searchInput.value.toLowerCase().trim();
        let salonsFound = false;
        let pointsCoordinates = [];

        for (const salonItem of this.partnerSalonItems) {
            let marker = this.findMarkerByLabel(salonItem.dataset.partnerSalonHash);

            if (query === '' || salonItem.dataset.search.includes(query)) {
                salonItem.classList.remove('u-hidden');
                marker.setVisible(true);
                pointsCoordinates.push([marker.position.lat(), marker.position.lng()]);
                salonsFound = true;
            } else {
                salonItem.classList.add('u-hidden');
                marker.setVisible(false);
            }
        }

        if (salonsFound) {
            this.noResultsPlaceholder.classList.add('u-hidden');
        } else {
            this.noResultsPlaceholder.classList.remove('u-hidden');
        }

        if (query !== '' && pointsCoordinates.length !== 0) {
            this.map.panTo(this.calculateCenter(pointsCoordinates));
            this.fitMapToBounds(pointsCoordinates);
        } else {
            this.map.panTo(this.defaultCenter);
            this.map.setZoom(this.getDefaultZoom());
        }

        //Nelze řešit pouze přes "visible". MarkerClusterer neschovává "clustery", i když v nich není žádný viditelný marker.
        this.clusterer.clearMarkers();
        this.clusterer.addMarkers(this.markers.filter(marker => marker.getVisible()));
    }

    scrollToMap() {
        this.$el.scrollIntoView({behavior: "smooth", inline: "nearest"});
    }

    findMarkerByLabel(label) {
        for (const infoWindow of this.infoWindows) {
            if (infoWindow.partnerSalonHash === label) {
                return infoWindow.marker;
            }
        }

        return null; //Nemělo by se nikdy stát
    }

    // Debounce method
    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
        };
    }

    calculateCenter(pointsCoordinates) {
        let latSum = 0;
        let lngSum = 0;

        pointsCoordinates.forEach(point => {
            latSum += point[0];
            lngSum += point[1];
        });

        return new google.maps.LatLng(latSum / pointsCoordinates.length, lngSum / pointsCoordinates.length);
    }

    fitMapToBounds(pointsCoordinates) {
        let bounds = new google.maps.LatLngBounds();
        pointsCoordinates.forEach(point => {
            bounds.extend(new google.maps.LatLng(point[0], point[1]));
        });
        this.map.fitBounds(bounds, 75);

        //Nastavuji maximální zoom, aby byla mapa rozumně čitelná
        if(this.map.getZoom() > 14){
            this.map.setZoom(14);
        }
    }

    getDefaultZoom() {
        if(this.isMobileDevice()){
            return 6;
        }
        return 7;
    }

    isMobileDevice() {
        return window.innerWidth <= 768;
    }
}